import type { IStudioEmbedLogConfig } from '@opm/utils/studioEmbedLog';
import type { IStudioTabPrNoticeMarqueeConfig } from '../StudioTabPrNoticeMarquee';

export type IMarketingStudioTabLogConfig = IStudioEmbedLogConfig;

export interface ITrendingPostsVdieoTabConfig {
  key: string;
  nameEn: string;
  nameCn: string;
  /** 与 compConfig 注册的组件 name 一致 */
  name: string;
  componentProps?: Record<string, unknown>;
  logConfig?: IMarketingStudioTabLogConfig;
  /** Tab 级跑马灯；未配置或 textEn/textZh 均为空时不展示 */
  prNoticeMarquee?: IStudioTabPrNoticeMarqueeConfig;
}

/** Studio TrendingPostsVdieo 各 Tab 共用的筛选器实例 ID（Tab 间继承，离开/刷新不继承） */
export const STUDIO_TRENDING_PUBLICATIONS_FILTER_INSTANCE_ID = 'studio-trending-publications';

export interface IZoneTrendingPublicationsAdapterStudioProps {
  contentType?: 'video' | 'posts';
  sourcePathname?: string;
  condGameIds?: string[];
}

export interface ITrendingPostsVdieoWrapperConfig {
  queryKey?: string;
  defaultTab?: string;
  titleEn?: string;
  titleCn?: string;
  descriptionEn?: string;
  descriptionCn?: string;
  /** 传入 Studio TrendingPostsVdieo 的 game_ids，各 Tab 可经 componentProps 覆盖 */
  condGameIds?: string[];
  tabs: ITrendingPostsVdieoTabConfig[];
}
